import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

const socialLinks = [
  { label: "Facebook", url: "https://www.facebook.com/people/Golden-SEA-Conciergerie-Val%C3%A9rie-Mayaud/61578043644997/", icon: "fb" },
  { label: "Instagram", url: "https://www.instagram.com/golden_sea_conciergerie", icon: "ig" },
  { label: "LinkedIn", url: "https://fr.linkedin.com/in/val%C3%A9rie-mayaud-5a8548187", icon: "li" },
];

function SocialIcon({ type }) {
  if (type === "fb") return (
    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
  );
  if (type === "ig") return (
    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
  );
  if (type === "li") return (
    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
  );
  return null;
}

export default function Footer() {
  return (
    <footer className="bg-[#111] text-white relative noise-overlay" data-testid="footer">
      <div className="relative z-10">
        <div className="section-container py-16">
          <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
            {/* Brand */}
            <div className="lg:col-span-1">
              <Link to="/">
                <img src="/images/logo.png" alt="Golden Sea Conciergerie" className="h-16 w-auto mb-4 brightness-0 invert" />
              </Link>
              <p className="text-sm text-white/60 leading-relaxed">
                Conciergerie premium pour vos biens en bord de mer.
              </p>
            </div>

            {/* Navigation */}
            <div>
              <h4 className="text-sm font-semibold uppercase tracking-wider text-[#d4af37] mb-4" style={{fontFamily: 'var(--font-sans)'}}>Navigation</h4>
              <ul className="space-y-2.5">
                <li><Link to="/" className="text-sm text-white/70 hover:text-[#d4af37] transition-colors">Accueil</Link></li>
                <li><Link to="/a-propos" className="text-sm text-white/70 hover:text-[#d4af37] transition-colors">À propos</Link></li>
                <li><Link to="/conciergerie" className="text-sm text-white/70 hover:text-[#d4af37] transition-colors">Conciergerie</Link></li>
                <li><Link to="/sous-location-conciergerie" className="text-sm text-white/70 hover:text-[#d4af37] transition-colors">Sous-location</Link></li>
                <li><Link to="/contact" className="text-sm text-white/70 hover:text-[#d4af37] transition-colors">Contact</Link></li>
                <li><Link to="/nos-actualites" className="text-sm text-white/70 hover:text-[#d4af37] transition-colors">Actualités</Link></li>
                <li><Link to="/faq" className="text-sm text-white/70 hover:text-[#d4af37] transition-colors">FAQ</Link></li>
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="text-sm font-semibold uppercase tracking-wider text-[#d4af37] mb-4" style={{fontFamily: 'var(--font-sans)'}}>Contact</h4>
              <ul className="space-y-3">
                <li className="flex items-center gap-2.5">
                  <Phone className="w-4 h-4 text-[#d4af37]" />
                  <a href="tel:0615166415" className="text-sm text-white/70 hover:text-white transition-colors">06 15 16 64 15</a>
                </li>
                <li className="flex items-center gap-2.5">
                  <Mail className="w-4 h-4 text-[#d4af37]" />
                  <a href="mailto:contact@goldensea-conciergerie.com" className="text-sm text-white/70 hover:text-white transition-colors">contact@goldensea-conciergerie.com</a>
                </li>
                <li className="flex items-start gap-2.5">
                  <MapPin className="w-4 h-4 text-[#d4af37] mt-0.5" />
                  <span className="text-sm text-white/70">La Grande-Motte, Aigues-Mortes,<br/>Carnon, Le Grau-du-Roi</span>
                </li>
              </ul>
            </div>

            {/* Social */}
            <div>
              <h4 className="text-sm font-semibold uppercase tracking-wider text-[#d4af37] mb-4" style={{fontFamily: 'var(--font-sans)'}}>Suivez-nous</h4>
              <div className="flex gap-3">
                {socialLinks.map((s, i) => (
                  <a
                    key={i}
                    href={s.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={s.label}
                    className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-white/70 hover:bg-[#d4af37] hover:text-[#111] transition-all duration-300"
                  >
                    <SocialIcon type={s.icon} />
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Bottom */}
          <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-white/40">&copy; {new Date().getFullYear()} Golden Sea Conciergerie. Tous droits réservés.</p>
            <div className="flex gap-4">
              <Link to="/politique-de-confidentialite" className="text-xs text-white/40 hover:text-white/70 transition-colors">Politique de confidentialité</Link>
              <Link to="/mentions-legales" className="text-xs text-white/40 hover:text-white/70 transition-colors">Mentions légales</Link>
              <Link to="/conditions-generales" className="text-xs text-white/40 hover:text-white/70 transition-colors">CGU</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
